import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseCloseHeader.module.scss'

import IconPrev20x20 from '@Root/ui/images/myhouse/IconPrev20x20.svg'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

const MyhouseCloseHeader: React.FC = () => {
  const history = useHistory()
  const handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault()
    handleNclick(NCLICK.MY_HOUSE.WITHDRAWAL.BACK, e)
    history.goBack()
  }

  return (
    <header className={cx('myhouse_close_header')}>
      <div className={cx('myhouse_header_inner')}>
        <a href="#" className={cx('myhouse_link_back')} aria-label="뒤로가기" onClick={handleClick}>
          <IconPrev20x20 />
        </a>
      </div>
    </header>
  )
}

export default MyhouseCloseHeader
